import {customElement} from 'aurelia-framework';

@customElement('sio-fullsize-column')
export class FullsizeColumn
{
}
